<script setup lang="ts">
    import { Popover, PopoverContent, PopoverTrigger } from "@/vue/ui/popover";
    import ChevronDown from '@svg/as/chevron-down.svg';
    import FilterButton from "@/vue/as/FilterButton.vue";
    import { AccordionItem, AccordionContent, AccordionHeader, AccordionTrigger } from "radix-vue";
    import { useBreakpoints } from "@/vue/composables/useBreakPoints";

    defineProps<{
        attribute: string,
        count: number,
    }>();
    const breakpoints = useBreakpoints();
</script>

<template>
    <div>
        <div class="hidden md:block">
            <Popover>
                <PopoverTrigger as-child>
                    <FilterButton>
                        <slot name="label"></slot>
                        <ChevronDown class="ml-2 w-4 h-4 group-aria-expanded/btn:-rotate-180" />
                    </FilterButton>
                </PopoverTrigger>
                <PopoverContent class="p-0 w-auto" :avoid-collisions="false" align="start">
                    <slot />
                </PopoverContent>
            </Popover>
        </div>
        <AccordionItem class="md:hidden border-b border-neutral-300" :value="attribute">
            <AccordionHeader class="flex">
                <AccordionTrigger class="flex flex-1 items-center justify-between py-4 font-medium transition-all [&[data-state=open]>svg]:rotate-180">
                    <div class="text-body font-medium">
                        <slot name="label" />
                        <template v-if="count">({{ count }})</template>
                    </div>
                    <slot name="icon">
                        <ChevronDown
                            class="h-8 w-8 shrink-0 transition-transform duration-200"
                        />
                    </slot>
                </AccordionTrigger>
            </AccordionHeader>
            <AccordionContent
                class="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
            >
                <div class="pb-8 pt-0">
                    <slot />
                </div>
            </AccordionContent>
        </AccordionItem>
    </div>
</template>
